import RequestStatus from "../model/RequestStatus";
import {GetRecommendationResponse} from "../model/Recommendation";
import {
    RECOMMENDATION_QUERY_START,
    RECOMMENDATION_QUERY_SUCCESS,
    RECOMMENDATION_QUERY_FAILED,
    RECOMMENDATION_REMOVE,
    GetRecommendationQueryComplete
} from "../actions/RecommendationQueryAction";

const initialState: GetRecommendationResponse = {
    requestStatus: RequestStatus.NOT_LOADED,
    data: null,
};

export default (
    state: GetRecommendationResponse = initialState,
    action: GetRecommendationQueryComplete
): GetRecommendationResponse => {
    switch (action.type) {
        case RECOMMENDATION_QUERY_START:
            return {
                requestStatus: RequestStatus.LOADING,
                data: null,
            };
        case RECOMMENDATION_QUERY_SUCCESS:
            return {
                requestStatus: RequestStatus.SUCCESS,
                data: action.recommendation,
            };
        case RECOMMENDATION_QUERY_FAILED:
            return {
                requestStatus: RequestStatus.ERROR,
                data: null,
            };
        case RECOMMENDATION_REMOVE:
            return initialState;
        default:
            return state;
    }
};
